{
  "_ARTVIKT": "Weight",
  "SEE_ALL_DOWNLOADS": "See all downloads",
  "PRODUCT_SPECIFICATION": "Product specification",
  "OH_TA_MAILNOTIFIED": "E-Mail, delivery information",
  "OH_Q_OH_TELEAVISERING": "Receiver’s telephone",
  "OH_EDITEXT": "Message",
  "TYLO_FREIGHT_COST": "Freight cost of <strong>{{value}} {{currencyCode}}</strong> will be added.",
  "TYLO_FREIGHT_COST_ERROR": "Freight cost could not be estimated",
  "TYLO_MIN_ORDER_ADMIN_FEE": "Admin fee {{fee}} will be applyed (min order {{min}})",
  "ADMIN_CHARGE": "Admin fee",
  "PART_DELIVERY": "Delivery Choice",
  "TYLO_PART_DELIVERY_MESSAGE": "The products will be partially delivered, freight will be charged on each delivery.",
  "TYLO_OH_LEVSATTKOD_1": "DSV",
  "TYLO_OH_LEVSATTKOD_5": "DSV, notification",
  "TYLO_OH_LEVSATTKOD_66": "DHL, Service Point",
  "TYLO_OH_LEVSATTKOD_67": "DHL, B2B",
  "TYLO_OH_DELLEVTILLATEN_0": "Yes",
  "TYLO_OH_DELLEVTILLATEN_10": "No",
  "TYLO_TRACK_ORDER": "Track and trace",
  "ADD_TO_CART": "Order",
  "CATEGORY_LEVEL_3": "Sub category",
  "DELIVERY_PLANNING": "Delivery planning",
  "TYLO_EDIT_DELIVERY_ADDRESS": "Order specific delivery address",
  "TYLO_DELIVERY_TIME_PRELIMINARY": "Delivery time is preliminary, the delivery date will be decided when the production is planned.",
  "CLAIM_FORM": "Claim form",
  "EDIT_NOTE": "Edit note",
  "HIDE_PRICE": "Hide price",
  "REQUEST_DELIVERY_DATE": "Requested delivery date",
  "RESTORE_AVAILABLE_DATES": "Restore available dates",
  "Q_MS_AR_COLOR": "Color",
  "Q_MS_AR_KW": "Wattage",
  "Q_MS_AR_RSIZE": "The amount of stones",
  "Q_MS_AR_SSIZE": "The size of the sauna",
  "ARTVIKT": "Net weight",
  "ARTBTOTVIKT": "Gross weight",
  "Q_MS_ARTLENGTH": "Product width",
  "Q_MS_ARTHEIGHT": "Product height",
  "Q_MS_ARTWIDTH": "Product depth",
  "Q_AR_LANGD": "Package width",
  "Q_AR_HOJD": "Package height",
  "Q_AR_BREDD": "package Depth",
  "Q_MS_AR_SD1": "Safety distance to the front",
  "Q_MS_AR_SD2": "Safety distance to the rear",
  "Q_MS_AR_SD3": "Safety distance up",
  "Q_MS_AR_SD4": "Safety distance to the sideways",
  "Q_MS_AR_SD5": "Safety distance from the water tank",
  "Q_MS_AR_SD6": "Safety distance down",
  "Q_MS_AR_VOLT1": "Voltage 1",
  "Q_MS_AR_VOLT2": "Voltage 2",
  "Q_MS_AR_VOLT3": "Voltage 3",
  "Q_MS_AR_VOLT4": "Voltage 4",
  "ARTSTATNR": "Customs code",
  "Q_AR_SSTL": "Electricity number",
  "ARTNREAN": "EAN product number",
  "URSPRUNGSLAND": "country of origin",
  "SHOW_ADVANCED": "Show advanced",
  "HIDE_ADVANCED": "Hide advanced",
  "VISIBLE_FOR_ASSORTMENTS": "Visible for assortments",
  "VISIBLE_FOR_CUSTOMERS": "Visible for customers",
  "HIDE_FOR_CUSTOMERS": "Hide for customers",
  "CART_ARTICLE_SKU_TOTAL": "{{article}} articles",
  "3D_CONFIGURATOR": "3D configurator",
  "BASE": "Category",
  "CUSTOM": "Category",
  "ARCTINAR": "Category",
  "TYLOINC": "Category",
  "BASESÄHKÖLIIKE": "Category",
  "CREDIT_BLOCKED": "Unable to place an order, please contact customer service",
  "AMOUNT_OF_CREDIT_LEFT": "Amount of credit left {{creditLeft}}",
  "VISIBLE_ON_DOCUMENT_PAGE": "Synlig på dokumentsidan",
  "COUNTRYOFORIGIN": "Country of origin",
  "SUPPLIERITEMID": "Supplier article number",
  "SUPPLIERITEMNAME": "Supplier article name",
  "PRODUCTGROUP": "Product group",
  "PRODUCTDISCOUNTCLASS": "Product discount class",
  "LEDOUTLETS": "LED outlets",
  "BENCHWIDTH": "Bench width",
  "FRAMEDIMENSIONWHD": "Frame dimensions (WHD)",
  "IPCCLASS": "IP-class",
  "STEAMPRODUCTION": "Steam production",
  "MAXLOAD": "Max load",
  "MAXLOAD_W": "Max load (W)",
  "HELO_ORDLEVADR_EXTRA": "Delivery address 2 (optional)",
  "HELO_ORDLEVADR_EXTRA2": "Delivery address 3 (optional)",
  "TYLO_DELIVERY": "Next delivery date",
  "SPLIT_DELIVERIES": "Split deliveries",
  "NET": "Net",
  "GROSS": "Gross",
  "TYLO_CART_NOTE": "By placing your orders on correct dates you avoid misunderstandings and storage fees. B2B orders are to be registered on the estimated date of dispatch. Registered orders go directly into our production and cannot be put on hold. Standard orders cannot be postponed or cancelled later than 5 working days prior to confirmed dispatch date.",
  "SELECT_DELIVERY": "Select Delivery Option",
  "DELIVERY_CHOICE_REQUIRED": "Delivery Choice is required",
  "HEIGHT": "Height (mm)",
  "WIDTH": "Width (mm)",
  "VOLTAGE": "Voltage (volts)",
  "ROOM_SIZE": "Room size (m3)",
  "POWER": "Power (kW)",
  "KW": "Power (kW)",
  "EFFECT_W": "Power (W)",
  "SAFETYDISTANCE_WALL": "Minimum distance to sidewall (mm)",
  "SAFETYDISTANCEWALL": "Minimum distance to sidewall (mm)",
  "SAFETYDISTANCE_CEILING": "Minimum ceiling height (mm)",
  "SAFETYDISTANCECEILING": "Minimum ceiling height (mm)",
  "CONTROLPANEL": "Control panel",
  "CONTROL_PANEL": "Control panel",
  "RELAYBOX": "Relay box",
  "RELAY_BOX": "Relay box",
  "OH_DELLEVTILLATEN_0": "Partial delivery",
  "OH_DELLEVTILLATEN_10": "Joint delivery",
  "ORDER_EDIT_TERMS": "Dispatch date can be changed 24 hour after placed order",
  "APPLY_ON_WHOLE_ORDER": "Check the box if you want to change the delivery date of all rows",
  "CLAIM_INFORMATION": "Please fill in the claim information as accurately as possible so that the complaint can be processed without delay. We only process claims in writing.",
  "TYPE": "Type",
  "PRODUCT_EXPORT_XLSX_IMAGES_DOCUMENTS": "XLSX images and documents",
  "CUSTOMER_ORDER_ID": "Customer Order Id",
  "CONCEPT_SHOW_DETAILS": "More options",
  "MORE_EXPECTED_DATE": "More expected in {{date}}",
  "SPAREPARTS": "Spareparts",
  "TYLO_ARRANGES_FREIGH": "Tylö arranges freight*",
  "HELO_ARRANGES_FREIGH": "Helo arranges freight*",
  "TYLO_ARRANGES_FREIGH_TERM": "*Minimum order value 500€. If the order value is lower, an admin fee of 30€ will be added.",
  "TYLO_ARRANGES_FREIGH_NOTE": "To avoid multiple freight sharges, make sure all rows have the same delivery dates. When the shipment is booked with a carrier, the price will be available under Previous orders",
  "TYLO_CART_NOTE_29_37": "The delivery date is preliminary and will manually be changed to first available delivery date (based on the lead time for each article) once your account balance is met.\n\nStandard orders cannot be postponed or cancelled later than 5 working days prior confirmed dispatch date.",
  "DAMAGED_IN_TRANSPORT": "Damaged in transport",
  "AMOUNT_OF_PRODUCTS": "Amount of products",
  "WRONG_PRODUCT": "Wrong product",
  "INVOICING": "Invoicing",
  "TECHNICAL_FAULT": "Technical fault",
  "TYLO_FREIGHT_COST_MANUAL": "The shipping price has not been calculated and will be calculated manually. Order acknowledgment containing shipping price will be sent separately.",
  "TYLO_TEMP_FREIGHT": "Temporary freight",
  "TYLO_TEMP_FREIGHT_DESCRIPTION": "Note that due to the current situation near the red sea, a temporary additional freight cost may be added to certain products.",
  "SAUNA_DEPTH_CM": "Sauna depth (cm):",
  "SAUNA_WIDTH_CM": "Sauna width (cm):",
  "SAUNA_HEIGHT_CM": "Sauna height (cm):",
  "UNINSULATED_SURFACE": "Uninsulated surface",
  "LASIOVI": "Lasiovi",
  "LOG_CONSTRUCTION": "Log construction",
  "SHOOT": "Shoot",
  "VOLUME_OF_YOUR_SAUNA": "The volume of your sauna is: {{volume}} m³",
  "CALCULATOR": "Calculator",
  "AVAILABLE_NUMBER_EXCEEDED_ALERT": "This product cannot be ordered in a higher quantity. Please contact our support at <a href='mailto:tps@sauna360.com'>tps@sauna360.com</a> and they will help you",
  "PARTIAL_DELIVERY_POPUP_TEXT": "When partial delivery, shipping will be charged at each time of delivery",
  "ESTIMATED_PRODUCTION_TIME": "Estimated production time is {{leadtime}} days",
  "EDIT_CUSTOMER_B2C_MARKUP": "Edit B2C markup for customer {{customerId}}",
  "DELIVERY_LOCATION_ORDER_SPECIFIC_INFO_TEXT": "In order to add an order-specific address, you must select Order-specific address in the dropdown below.",
  "DESCRIBE_THE_ISSUE": "Discribe the issue",
  "RETURN_STATUS": "Return Status",
  "RETURNED_TO_TYLO": "Returned to Tylö",
  "NOT_RETURNED_TO_TYLO": "Not returned to Tylö",
  "DATE_OF_SALE": "Date of Sale",
  "DATE_FAULT_OCCURRED": "Date Fault Occurred",
  "TYPE_OF_USE": "Type of Use",
  "COMMERCIAL": "Commercial",
  "AUTOMATICALLY_ADDED_WHEN_ROW_IS_SELECTED": "Automatically added when orderrow is selected",
  "HELO_DELIVERED_FROM_CONTACT": "If there are any questions, please contact export.se@sauna360.com"
}
